import { useEffect, useState } from "react";
import { getGitchaAvailableCities , getGeoLocation} from "../services/commonServices";
import { toTitleCase , setLocalStorage} from "../helpers/common";


const GitchaAvailableLocations = (props) =>{
    const [availableLocations, setAvailableLocations] = useState([])
    useEffect(()=>{
        fetchGitchaAvailableCities()
    }, [])

    const fetchGitchaAvailableCities = async()=>{
        await getGitchaAvailableCities().then((response)=>{
            const res = _.get(response, "result", [])
            setAvailableLocations(res)
        }).catch((error)=>console.log(error))
    }

    const handleLocationSelect = async(loc) => {
        const reqPayload = `address=${loc.City},${loc.State}`;
        await getGeoLocation(reqPayload).then((data) => {
            const results = _.get(data, "results");
            if (results?.length > 0) {
                const address = results[0];
                const geometry = _.get(address, "geometry", "");
                const locBounds = _.get(geometry, "location", "");
                const lat = _.get(locBounds, "lat", "")
                const long = _.get(locBounds, "lng", "")
                const formatted_address = _.get(address, "formatted_address", "");
                setLocalStorage("searchedLocation", {latitude:lat, longitude:long, formatted_address:toTitleCase(loc.City)+", "+toTitleCase(loc.State)})
                props.setUserLocation({latitude:lat, longitude:long, formatted_address:toTitleCase(loc.City)+", "+toTitleCase(loc.State)})
            } 
          });
    }

    return(
        <>
        <h3>Gitcha isn’t operating in this area (yet!)</h3>
        <p>We’re coming to your area soon. Here are the areas we’re currently operating in:</p>
        <ul className="operating-areas-list">
        {availableLocations?.length>0 &&
            availableLocations.map((loc)=>{
                return <li>
                    <a href={void(0)} onClick={()=>handleLocationSelect(loc)}>{toTitleCase(loc.City)}, {toTitleCase(loc.State)}</a>
                </li>
            })
        }
        </ul>        
        </>
    )
}

export default GitchaAvailableLocations;